import * as Common from '@/tenant/common';

export class StockBalanceJournal extends Common.StateObject2{
  constructor(className: string){
    super(className);
    this.binders.segment = new Common.ModelBinder(Common.Segment);
    this.binders.commodity = new Common.ModelBinder(Common.Commodity);
    this.binders.sku = new Common.ModelBinder(Common.SKU);
    this.binders.warehouse = new Common.ModelBinder(Common.Counterpart);
    this.binders.stockPricing = new Common.ModelBinder(Common.StockPricing);
    this.binders.stockBalance = new Common.ModelBinder(Common.StockBalance);
  }

  public salesPurchaseFlag: Common.SalesPurchaseFlags  = 0;
  public segmentId: number = 0;
  public segment: Common.Segment = null;
  public warehouseId: number= null;
  public warehouse: Common.Counterpart = null;
  public commodityId: number = 0;
  public commodity: Common.Commodity = null;
  public skuId: number= null;
  public sku: Common.SKU = null;
  //案件
  public projectItemNo : string = null;
  public projectItem : Common.ProjectItem = null;
  // 予備項目
  public reserveText1: string  = '';
  public reserveText2: string  = '';
  public reserveText3: string  = '';
  public reserveText4: string  = '';
  public reserveText5: string  = '';
  public reserveText6: string  = '';
  public reserveMemo1: string  = '';
  public reserveMemo2: string  = '';
  public reserveMemo3: string  = '';
  public reserveDate1: Date  = null;
  public reserveDate2: Date  = null;
  public reserveDate3: Date  = null;
  public reserveList1: number  = null;
  public reserveList2: number  = null;
  public reserveList3: number  = null;

  public unitPrice: number = 0;
  public taxCode: string = '';
  public package: string = '';
  public quantity: number = 0;
  public adjustmentQuantity: number = 0;

  // 在庫
  public stockBalanceId: number= null;
  public stockBalance: Common.StockBalance = null;
  public stockPricingId: number= null;
  public stockPricing: Common.StockPricing = null;

  // 金額
  public dealAmountFC: number = 0;
  public amountFC: number = 0;
  public taxAmountFC: number = 0;
  public totalAmountFC: number = 0;
  public amount: number = 0;
  public taxAmount: number = 0;
  public totalAmount: number = 0;

  // 在庫詳細
  public undeliveredQuantity: number = 0;
  public undeliveredAmount: number = 0;
  public purchaseQuantity: number = 0;
  public purchaseAmount: number = 0;
  public purchaseChargeAmount: number = 0;
  public transferQuantity: number = 0;
  public transferAmount: number = 0;
  public consignmentQuantity: number = 0;
  public consignmentAmount: number = 0;
  public salesQuantity: number = 0;
  public salesAmount: number = 0;
  public salesChargeAmount: number = 0;
  public differentialQuantityActual: number = 0;
  public quantityLossAmount: number = 0;
  public totalUndeliveredQuantity: number = 0;
  public totalUndeliveredAmount: number = 0;
  public totalConsignmentQuantity: number = 0;
  public totalConsignmentAmount: number = 0;
  public totalStockQuantity: number = 0;
  public stockQuantity: number = 0;  
  public totalStockAmount: number = 0;
  public schedulePurchaseQuantity: number = 0;
  public scheduleSalesQuantity: number = 0;
  public totalScheduleStockQuantity: number = 0;

  // 単価詳細
  public receiptQuantity: number = 0;
  public receiptPrice: number = 0;
  public receiptAmount: number = 0;
  public withDrawQuantity: number = 0;
  public withDrawPrice: number = 0;
  public withDrawAmount: number = 0;
  public pricingWithDrawAmount: number = 0;
  public pricingQuantity: number = 0;
  public pricingAmount: number = 0;
  public pricingPrice: number = 0;
  public lastPurchaseQuantity: number = 0;
  public lastPurchaseAmount: number = 0;
  public lastPurchasePrice: number = 0;
}

export enum StockBalanceJournalStatus
{
  SalesDelivery = 1, // 出荷明細
  PurchaseDelivery = 2, // 入荷明細
  StockRelocation = 4, // 在庫移動明細
  Charge = 8, // 諸掛明細
  StockTaking = 16, // 棚卸処理明細
  StockTransfer = 32, // 在庫振替
  Instruction = 64, // 連携指示中

  SalesDeliveryInstructionWaiting = SalesDelivery + 256, // 出荷指示待ち
  SalesDelivering = SalesDelivery + 512, // 出荷確定待ち
  SalesDeliveryInspectionWaiting = SalesDelivery + 1024, // 検品待ち
  SalesDeliveryItem = SalesDeliveryInstructionWaiting | SalesDelivering | SalesDeliveryInspectionWaiting, //未確定?
  SalesDeliveryAcceptanceWaiting = SalesDelivery + 2048, // 請求処理待ち
  SalesDeliveryClosingWaiting = SalesDelivery + 4096, // 請求締待ち
  SalesDeliveryCompleted = SalesDelivery + 8192, // 完了
  SalesDeliveryNotCompleted = SalesDeliveryAcceptanceWaiting | SalesDeliveryClosingWaiting,
  SalesDeliveryInvoiceItem = SalesDeliveryAcceptanceWaiting | SalesDeliveryClosingWaiting | SalesDeliveryCompleted,
  SalseDeliveryAllItem = SalesDeliveryItem  |  SalesDeliveryInvoiceItem, //すべての出荷明細、検索用

  PurchaseDeliverySaving = PurchaseDelivery + 256, // 入荷確定待ち
  PurchaseDelivering = PurchaseDelivery + 512, // 入荷確定待ち(未着品)
  PurchaseDeliveryInstruction = PurchaseDelivery + 256 + Instruction, // 入荷指示待ち
  PurchaseDeliveringInstruction = PurchaseDelivery + 512 + Instruction, // 入荷指示待ち(未着品)
  PurchaseDeliveryInspectionWaiting = PurchaseDelivery + 1024, // 検品待ち
  PurchaseDeliveryCompleted = PurchaseDelivery + 2048, // 完了=>出荷
  PurchasePostCompleted = PurchaseDelivery + 4096, //完了(仮想フラグ)
  PurchaseDeliveryNotCompleted = PurchaseDeliverySaving | PurchaseDelivering | PurchaseDeliveryInspectionWaiting | PurchaseDeliveryCompleted | PurchaseDeliveringInstruction | PurchaseDeliveryInstruction,//完了以外
  PurchaseDeliveryDelivered = PurchaseDeliveryCompleted | PurchasePostCompleted, //入荷済み

  StockRelocationNone = StockRelocation + 256, // 在庫移動(ワークフロー制御なし)

  ChargeNotCompleted = Charge + 256, // 未完了
  ChargeCompleted = Charge + 512, // 完了

  StockTakingWaiting = StockTaking + 256, // 棚卸処理待ち
  StockTakingInspectionWaiting = StockTaking + 512, // 検品待ち
  StockTakingCompleted = StockTaking + 1024, // 完了

  StockTransferWaiting= StockTransfer + 256, // 在庫振替待ち
  StockTransferCompleted= StockTransfer + 512, // 完了
}